module.exports = __webpack_public_path__ + "static/media/scott-chacon_200x200.ae174513.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/scott-chacon_200x200.png
// module id = 321
// module chunks = 0